import { Selector } from 'react-redux';

import { MandantConfigState } from './MandantConfigState';

export const getMandantData: Selector<
  { MandantConfig: MandantConfigState },
  MandantConfigState['data']
> = ({ MandantConfig: { data } }) => data;

export const mandantConfigIsLoading: Selector<{ MandantConfig: MandantConfigState }, any> = ({
  MandantConfig: { loading },
}) => loading;

export const getTranslation: Selector<{ MandantConfig: MandantConfigState }, any> = ({
  MandantConfig: { translation },
}) => translation;

export const getForgotPasswordProcessURL: Selector<{ MandantConfig: MandantConfigState }, any> = ({
  MandantConfig: { data },
}) => data?.urls?.forgotPasswordProcessURL;
